import { useEffect, useState } from "react";
import Select from "../../components/input/Select";
import SearchFilter from "../../components/input/SearchFilter";
import { Loading } from "../../components/Loading";
import SimplePagination from "../../components/SimplePagination";
import SchoolCoursesTable from "./SchoolCoursesTable";
import { CourseListQueryModel, useSchoolCoursesListQuery } from "./schoolsApiSlice";

interface SchoolCoursesProps {
	schoolId: number;
}

export default function SchoolCoursesSection(props: SchoolCoursesProps) {
	const _displayLength = 5;
	const initQueryargs: CourseListQueryModel = {
		iDisplayStart: 0,
		iDisplayLength: _displayLength,
		iSortCol_0: 0,
		sSortDir_0: "desc",
		school_id: props.schoolId,
		search_filter: "",
		active_filter: "true",
	};

	const [queryargs, setQueryargs] = useState(initQueryargs);
	const [page, setPage] = useState(0);
	const [searchFilter, setSearchFilter] = useState("");
	const [statusFilter, setStatusFilter] = useState("true");
	const [isFiltered, setIsFiltered] = useState(false);

	const schoolCoursesResult = useSchoolCoursesListQuery(queryargs);
	const courses = schoolCoursesResult.data;

	useEffect(() => {
		setQueryargs({
			...queryargs,
			iDisplayStart: _displayLength * page,
			search_filter: searchFilter,
			active_filter: statusFilter,
		});
	}, [page, searchFilter, statusFilter]);

	useEffect(() => {
		setIsFiltered(!!searchFilter || JSON.parse(statusFilter));
		setPage(0);
	}, [searchFilter, statusFilter]);

	const handlePageChange = (page: number) => {
		setPage(page);
	};

	return (
		<section>
			<hr className="my-6" />
			<h2>Courses</h2>
			<div className="flex justify-between items-end">
				<div className="flex gap-3 mt-4 items-end">
					<Select
						value={statusFilter}
						setValue={(v) => setStatusFilter(v as string)}
						label="Status"
						simpleListBoxId="statusFilter"
						options={[
							{
								value: "true",
								label: "Active Courses",
							},
							{
								value: "false",
								label: "All Courses",
							},
						]}
						fieldClasses="w-56"
					/>
					<SearchFilter
						id="courseSearch"
						name="courseSearch"
						searchFilter={searchFilter}
						setSearchFilter={setSearchFilter}
						label="Search"
						placeHolder="Search by name or referral code..."
						className="w-80"
					/>
				</div>
			</div>
			<Loading loading={schoolCoursesResult.isLoading} />
			{courses && <SchoolCoursesTable courses={courses.aaData} />}
			<SimplePagination
				itemCount={courses?.iTotalDisplayRecords}
				page={page}
				pageSize={queryargs.iDisplayLength}
				totalCount={courses?.iTotalRecords}
				isFiltered={isFiltered}
				onChange={(page) => handlePageChange(page)}
				className={"border-none"}
			/>
		</section>
	);
}
